import { fetch } from '@utils/utils';

// ziskanie zaznamu
export const getRecordFromEventId = ({ addError }) => async eventId => {
  try {
    const response: any = await fetch('/metropolis/api/common/sps/records', {
      method: 'GET',
      params: {
        'filter[0].field': 'internalId',
        'filter[0].operation': 'EQ',
        'filter[0].value': eventId
      }
    });

    const json = await response.json();

    const { items, count } = json;
    if (count) {
      return items[0];
    } else {
      return null;
    }
  } catch (err) {
    addError(err.message);
    return null;
  }
};

// Ziskanie dokumentov
export const getDocumentsFromEventId = ({ addError }) => async eventId => {
  try {
    const response: any = await fetch('/metropolis/api/common/sps/documents', {
      method: 'GET',
      params: {
        'filter[0].field': 'internalId',
        'filter[0].operation': 'EQ',
        'filter[0].value': eventId,
        pageSize: -1
      }
    });

    const json = await response.json();

    const { items } = json;
    const itemsFiltered = items.map(i => ({ ...i, attachments: i.attachments.filter(a => !a.deleted) }));
    return itemsFiltered;
  } catch (err) {
    addError(err.message);
    return [];
  }
};

// Vytvorenie zaznamu (novy spis)
export const createRecord = ({ addError, addSuccess }) => async formData => {
  try {
    const response: any = await fetch('/metropolis/api/ed/record/create', {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      params: { recordCase: null, ...formData }
    });

    if (response.ok) {
      const record = await response.json();
      addSuccess('Nový spis vytvořen');
      return record;
    }
    addError();
    return null;
  } catch (err) {
    addError(err.message);
    return null;
  }
};

// Priradenie dokumentu k zaznamu  (Priradit do spisu)
export const assignRecordDocument = ({ addError, addSuccess }) => async formData => {
  try {
    const response: any = await fetch('/metropolis/api/ed/record/assign-document', {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      // recordId & documentId
      params: formData
    });

    if (response.ok) {
      addSuccess('Dokument přiřazen do spisu');
      return true;
    }
    addError();
    return false;
  } catch (err) {
    addError(err.message);
    return null;
  }
};

// Vytvorenie dokumentu
export const createDocument = ({ addError }) => async (formData, eventId) => {
  try {
    const response: any = await fetch('/metropolis/api/ed/record/create-document', {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(formData),
      params: { eventId }
    });

    const record = await response.json();

    return record;
  } catch (err) {
    addError(err.message);
    return null;
  }
};

// Uložení přílohy dokumentu
export const createAttachment = ({ addError, addSuccess }) => async (formData, documentId, update = false) => {
  try {
    const response: any = await fetch('/metropolis/api/ed/record/save-document-attachment', {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify({ attachment: formData }),
      params: { documentId }
    });

    if (response.ok) {
      addSuccess(update ? 'Příloha byla aktualizována' : 'Příloha byla přidána k dokumentu');
      const attachment = await response.json();
      return attachment;
    }
    addError();
    return null;
  } catch (err) {
    addError(err.message);
    return null;
  }
};

// Odstranenie přílohy dokumentu
export const deleteAttachment = ({ addError, addSuccess }) => async (documentId, attachmentId) => {
  try {
    const response: any = await fetch('/metropolis/api/ed/record/document-attachment', {
      method: 'DELETE',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      params: { documentId, attachmentId }
    });

    if (response.ok) {
      addSuccess('Příloha byla odstraněna');
      return true;
    }
    addError();
    return false;
  } catch (err) {
    addError(err.message);
    return false;
  }
};

// Odeslat spis
export const returnRecord = ({ addSuccess, addError }) => async (id: string) => {
  try {
    const response = await fetch(`/metropolis/api/ed/record/return/${id}`, {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    if (response.ok) {
      addSuccess('Spis úspěšně odeslán');
      return true;
    }
    addError('Nepodařilo se odeslat spis');
    return false;
  } catch (e) {
    addError('Nepodařilo se odeslat spis');
    return false;
  }
};

// Vymazat dokument
export const cancelDocument = async (id: string): Promise<any> => {
  try {
    await fetch(`/metropolis/api/ed/record/geosps/cancel-document/${id}`, {
      method: 'DELETE',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });
    return true;
  } catch (err) {
    return false;
  }
};

// Zrušit spis
export const cancelRecord = ({ addSuccess, addError }) => async (id: string) => {
  try {
    const response = await fetch(`/metropolis/api/ed/record/geosps/cancel-record/${id}`, {
      method: 'DELETE',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    if (response.ok) {
      addSuccess('Spis úspěšně zrušen');
      return true;
    }
    addError('Nepodařilo se zrušit spis');
    return false;
  } catch (e) {
    addError('Nepodařilo se zrušit spis');
    return false;
  }
};



// WEBPACK FOOTER //
// ./src/modules/records/_recordsActions.ts